<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'BannerCenter',
            to: {
              name: 'BannerCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'BannerCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增橫幅廣告</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增橫幅廣告 -->
    <SlidebannerCreateEdit></SlidebannerCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SlidebannerCreateEdit from '@/views/B-12__SlideBanner/c/SlidebannerCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    SlidebannerCreateEdit,
  },
  computed: {
    ...mapState('slidebanner', ['slidebanner']),
  },
  created() {
    this.set_Slidebanner({});
  },
  methods: {
    ...mapActions('slidebanner', ['set_Slidebanner', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'BannerCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.slidebanner.bu_id) {
          this.errors.push('BU required.');
        } else if (!this.slidebanner.title) {
          this.errors.push('標題 required.');
        } else if (!this.slidebanner.position) {
          this.errors.push('Position required.');
        } else if (!this.slidebanner.type) {
          this.errors.push('Type required.');
        } else if (!this.slidebanner.visual) {
          this.errors.push('Visual required.');
        } else if (!this.slidebanner.mobile_visual) {
          this.errors.push('Visual for Mobile required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.slidebanner).then(() => {
          this.$router.push({ name: 'BannerCenter' });
        });
      }
    },
  },
};
</script>

<style></style>
